module.exports = __webpack_public_path__ + "img/1982_uk.b57eaec9.svg";